export default __webpack_public_path__ + "static/group-62-6aecb570c89ca0cb0158db5db7a60d5f.png";